module.exports = __webpack_public_path__ + "media/sub7-5-4.0038af19.mp4";